module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.3d011804.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-SemiBold.woff2
// module id = 704
// module chunks = 21